<template>
  <!-- <hm-content title=''> -->
  <div class="overview">
    <div class="p10 overview-tip">
      自动化周期性营销场景，在商品复购周期内，对即将复购的客户推送提醒信息提升复购率！
    </div>
    <div class="overview-box">
      <div class="title">复购数据</div>
      <div class="flex flex-center mt20">
        <div
          class="flex-1 flex purchase-data p10 pointer"
          :class="{ mr20: i < list.length - 1 }"
          @click="gogogo(v)"
          v-for="(v, i) in list"
          :key="i"
        >
          <div class="hm-icon mr10">
            <span class="hmicon" :class="v.icon"></span>
          </div>
          <div class="flex-1">
            <el-tooltip
              class="tooltip"
              effect="light"
              :content="v.tip"
              placement="top"
              :disabled="i !== 1"
            >
              <span class="purchase-name mt10">
                {{ v.name }}
                <i
                  v-if="i === 1"
                  class="el-icon-question"
                  style="font-size: 18px; color: #ddd"
                ></i>
              </span>
            </el-tooltip>
            <div class="mt10 flex flex-between item-center">
              <div class="purchase-val">
                {{ v.val }}
              </div>
              <div style="font-size: 14px" v-if="i !== 1">
                <span class="mr10"
                  >{{ i === 0 ? "前日" : "昨日" }} {{ v.oldValue }}
                </span>
                增减
                <span v-if="v.val - v.oldValue >= 0">
                  <span class="success">+ {{ v.val - v.oldValue }}</span>
                  <span class="el-icon-top success"></span>
                </span>
                <span v-else>
                  <span class="danger">{{ v.val - v.oldValue }}</span>
                  <span class="el-icon-bottom danger"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="overview-box">
      <div class="flex flex-between">
        <div class="title">复购提醒计划</div>
        <div @click="morePlan" class="gray pointer" style="font-size: 14px">
          更多 <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <div class="mb10 mt10">
        <el-button @click="add" type="primary" size="small"
          >创建复购提醒计划</el-button
        >
      </div>
      <div>
        <el-table
          stripe
          ref="btable"
          :data="planList"
          style="width: 100%"
          id="table"
          size="small"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="planName"
            label="计划名称"
            width="200"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            width="200"
            label="计划时间"
          >
            <template slot-scope="scope">
              {{ scope.row.planStartDate }}至{{ scope.row.planEndDate }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="planDiagnosisStatus"
            label="计划诊断"
          >
            <template slot="header" slot-scope="scope">
              计划诊断
              <el-tooltip
                class="tooltip"
                effect="light"
                placement="top"
                :content="daysTip"
              >
                <i class="el-icon-question" style="font-size: 18px"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-popover
                placement="right"
                trigger="click"
                content="这是一段内容,这是一段内容,这是一段内容,这是一段内容。"
                @show="tipShow(scope.row)"
                @after-leave="tipGoods = []"
                :disabled="scope.row.planDiagnosisStatus !== 'suggestOptimize'"
              >
                <div>
                  <div class="mb10" style="font-weight: bold; font-size: 16px">
                    该提醒计划建议优化
                  </div>
                  <div v-if="tipGoods.length">
                    <div v-for="(v, i) in tipGoods" :key="i">
                      <span class="gray mr10">
                        {{ v.spuName }} {{ v.specIdGroupName }}</span
                      >
                      <span class="orange"
                        >最近{{ configModel.daysAfterPlan }}天转化率低于{{
                          configModel.minValue
                        }}%</span
                      >
                    </div>
                  </div>

                  <div v-else class="gray">暂无待优化商品</div>
                  <div class="orange mt10">* 优化后次日查看效果</div>
                  <div class="mt10">
                    <el-button
                      size="small"
                      type="primary"
                      @click="edit(scope.row)"
                      >现在去优化</el-button
                    >
                  </div>
                </div>
                <template slot="reference">
                  <span
                    v-if="scope.row.planDiagnosisStatus === 'normal'"
                    class="success"
                    >表现良好
                    <span
                      style="font-size: 15px; margin-left: 5px"
                      class="el-icon-circle-check"
                    ></span>
                  </span>
                  <span
                    class="danger pointer"
                    v-else-if="
                      scope.row.planDiagnosisStatus === 'suggestOptimize'
                    "
                  >
                    建议优化<span
                      style="font-size: 15px; margin-left: 5px"
                      class="el-icon-warning-outline"
                    ></span>
                  </span>
                  <span v-else class="gray">
                    数据不足
                    <!-- {{ scope.row.planDiagnosisStatus }} -->
                  </span>
                </template>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="totalNoticeNum"
            label="通知次数"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="totalVisitNum"
            label="通知访问次数"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="proportion"
            label="复购率"
          >
            <!-- <template slot-scope="scope">
            {{ToFixed(scope.row.proportion,2)}}
          </template> -->
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="spuName"
            label="状态"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.planStatus === 'notStart'" class="gray">
                未开始
              </div>
              <div
                v-else-if="scope.row.planStatus === 'running'"
                class="success"
              >
                进行中
              </div>
              <div v-else-if="scope.row.planStatus === 'end'" class="gray">
                已结束
              </div>
              <div
                v-else-if="scope.row.planStatus === 'errorStop'"
                class="danger"
              >
                异常暂停
              </div>
              <div v-else-if="scope.row.planStatus === 'stop'" class="orange">
                暂停
              </div>
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            width="200"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="details(scope.row)"
                >数据</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="edit(scope.row)"
                >编辑</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                @click="operate(scope.row)"
                v-if="
                  scope.row.planStatus === 'notStart' ||
                    scope.row.planStatus === 'end'
                "
                size="small"
                type="text"
                class="gray"
                :disabled="
                  scope.row.planStatus === 'notStart' ||
                    scope.row.planStatus === 'end'
                "
                >{{
                  scope.row.planStatus === "errorStop" ||
                  scope.row.planStatus === "stop"
                    ? "开启"
                    : "暂停"
                }}</el-button
              >
              <el-button
                @click="operate(scope.row)"
                v-else
                size="small"
                type="text"
                :class="
                  scope.row.planStatus === 'errorStop' ||
                  scope.row.planStatus === 'stop'
                    ? 'success'
                    : 'orange'
                "
                >{{
                  scope.row.planStatus === "errorStop" ||
                  scope.row.planStatus === "stop"
                    ? "开启"
                    : "暂停"
                }}</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                size="small"
                class="danger"
                type="text"
                @click="del(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="overview-box">
      <div class="title">复购效果</div>
      <div class="flex flex-end">
        <!-- <el-select
          v-model="searchCondition.queryType"
          size="small"
          class="mr10"
        >
          <el-option label="全部" value="all"></el-option>
        </el-select> -->
        <el-date-picker
          clearable
          v-model="searchCondition.createTimeArry"
          type="daterange"
          align="right"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
          @change="createTimeArryChange"
        ></el-date-picker>
      </div>
      <div class="flex mt20">
        <div
          v-for="(v, i) in h"
          :key="i"
          @click="detail(i, v)"
          class="tab-btn text-center pointer"
        >
          <div class="hh" :style="{ background: v.background }"></div>
          <div class="p10" :style="{ background: active === i ? v.rgba : '' }">
            <div style="font-size: 14px">
              {{ v.name }}
            </div>
            <div style="font-weight: bold; font-size: 20px" v-if="i === 3">
              ￥{{ toPriceNum(v.val.toFixed(2)) }}
            </div>
            <div style="font-weight: bold; font-size: 20px" v-else>
              {{ v.val }}
            </div>
          </div>
        </div>
      </div>
      <div>
        <div id="mainline" style="height: 400px"></div>
      </div>
    </div>
  </div>
  <!-- </hm-content> -->
</template>

<script>
import echarts from "echarts";
import { ToFixed } from "@/utils/utils";
// var echarts = require("echarts/lib/echarts");
// require("echarts/lib/chart/bar");
// require("echarts/lib/component/title");
// require("echarts/lib/chart/line");
import moment from "moment";
export default {
  components: {},
  data() {
    return {
      // ToFixed,
      daysTip: "",
      tipGoods: [],
      configModel: {},
      active: 0,
      h: [
        {
          name: "通知次数",
          val: 0,
          background: "#B839F2",
          rgba:
            "linear-gradient(180deg, rgba(184, 57, 242, 0.3) 0%, rgba(255, 255, 255, 0) 100%)",
          queryStatus: "notice"
        },
        {
          name: "访问次数",
          val: 0,
          background: "#F58D34",
          rgba:
            "linear-gradient(180deg, rgba(245, 141, 52, 0.3) 0%, rgba(255, 255, 255, 0) 100%)",
          queryStatus: "visit"
        },
        {
          name: "复购次数",
          val: 0,
          background: "#16CEB9",
          rgba:
            "linear-gradient(180deg, rgba(22, 206, 185, 0.3) 0%, rgba(255, 255, 255, 0) 100%)",
          queryStatus: "pay"
        },
        {
          name: "复购金额",
          val: 0,
          background: "#0081E5",
          rgba:
            "linear-gradient(180deg, rgba(0, 129, 229, 0.3) 0%, rgba(255, 255, 255, 0) 100%)",
          queryStatus: "payPrice"
        }
      ],
      searchCondition: {
        createTimeArry: []
      },
      list: [
        // {
        //   icon: "icon-fugoudingdanshu1",
        //   name: "今日实时复购订单数（单）",
        //   val: "9641",
        //   pathName: "AfterPurchaseOrder",
        //   type: "today"
        // },
        {
          icon: "icon-fugoudingdanshu1",
          name: "昨日复购订单数（单）",
          val: 0,
          pathName: "AfterPurchaseOrder",
          type: "yesterday",
          oldValue: 0
        },
        {
          icon: "icon-qianlishangpin1",
          name: "挑选复购商品",
          val: 0,
          pathName: "PotentialGoods",
          type: "",
          tip: "自动为您挑选出复购概率较大的商品"
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "今日消息通知数",
          val: 0,
          pathName: "PurchaseMsgPush",
          type: "",
          oldValue: 0
        }
      ],
      planList: [],
      optionLineData: [],
      optionLine: {
        tooltip: {
          trigger: "axis"
        },
        xAxis: {
          type: "category",
          data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
        },
        yAxis: {
          type: "value",
          axisLabel: {},
          minInterval: 1
        },
        series: [
          {
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: "line",
            smooth: true,
            itemStyle: {
              normal: {
                lineStyle: {
                  color: "#B839F2"
                }
              }
            },
            areaStyle: {
              color: "#B839F2"
            }
          }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryDetails();
  },
  mounted() {
    this.searchCondition.createTimeArry = [
      moment(new Date())
        .add(-7, "days")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ];
    this.queryList();
    this.queryPhysiologicalBehaviorList();
    this.queryRepurchasePlanExecData();
    this.queryRepurchasePlanExecDataByStoreCode();
  },
  activated() {
    this.quertPurchasePlanList();
    this.queryDetails();
  },
  methods: {
    async queryDetails() {
      const { code, result } = await this.$store.dispatch(
        "queryRepurchasePlanDiagnosisConfig"
      );

      if (code === "0") {
        if (result.daysAfterPlan) {
          this.daysTip = "计划创建后" + result.daysAfterPlan + "天开始诊断";
        } else {
          this.daysTip = "暂未设置诊断时间";
        }
      }
    },
    async tipShow(row) {
      const { code, result } = await this.$store.dispatch(
        "querySuggestOptimizeSkuList",
        row
      );

      if (code === "0") {
        this.tipGoods = result.planSkuRelModels;
        this.configModel = result.configModel;
      }
    },
    createTimeArryChange() {
      this.queryPhysiologicalBehaviorList();
      this.queryRepurchasePlanExecDataByStoreCode()
    },
    async queryRepurchasePlanExecDataByStoreCode() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0] + " 00:00:00"
          : null;
      searchCondition.queryEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1] + " 23:59:59"
          : null;
      const { code, result } = await this.$store.dispatch(
        "queryRepurchasePlanExecDataByStoreCode",
        searchCondition
      );

      if (code === "0") {
        this.h[0].val = result.noticeNum;
        this.h[1].val = result.visitNum;
        this.h[2].val = result.payNum;
        this.h[3].val = result.payPrice;
      }
    },
    toPriceNum(num) {
      if (isNaN(num)) {
        num = 0;
      }
      return (
        num &&
        num.toString().replace(/\d+/, function(s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    },
    async queryRepurchasePlanExecData() {
      const { code, result } = await this.$store.dispatch(
        "queryRepurchasePlanExecData"
      );

      if (code === "0") {
        this.list[0].val = result.yesterdayPayNum;
        this.list[0].oldValue = result.beforeYesterdayPayNum;
        this.list[1].val = result.potentialSkuNum;
        this.list[2].val = result.todayNoticeNum;
        this.list[2].oldValue = result.yesterdayNoticeNum;
      }
    },
    async queryPhysiologicalBehaviorList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryStartTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0] + " 00:00:00"
          : null;
      searchCondition.queryEndTime =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1] + " 23:59:59"
          : null;
      searchCondition.queryStatus = this.h[this.active].queryStatus;
      const { code, result } = await this.$store.dispatch(
        "queryRepurchasePlanExecDataByQueryStatus",
        searchCondition
      );

      if (code === "0") {
        this.optionLineData = result;
        let time = [];
        let data = [];
        result.forEach(v => {
          time.push(v.date);
          data.push(v.returnValue);
        });
        this.optionLine.xAxis.data = time;
        this.optionLine.series[0].data = data;
        if (searchCondition.queryStatus === "payPrice") {
          this.optionLine.tooltip.formatter = `{b0}<br />${
            this.h[this.active].name
          }:{c0}元`;
        } else {
          this.optionLine.tooltip.formatter = `{b0}<br />${
            this.h[this.active].name
          }:{c0}人`;
        }
        this.$nextTick(() => {
          let myChart = echarts.init(document.getElementById("mainline"));
          myChart.setOption(this.optionLine);
        });
      }
      // setTimeout(() => {

      // }, 100);
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      // const { code, result } = await this.$store.dispatch(
      //   "physiologicalBehaviorList",
      //   searchCondition
      // );
      // if (code === "0") {
      //   this.h.forEach(v => {
      //     v.val = result[v.behaviorType + "MemberNumber"] || 0;
      //   });
      //   setTimeout(() => {
      //     let myChart = echarts.init(document.getElementById("mainline"));
      //     myChart.setOption(this.optionLine);
      //   }, 100);
      // }
    },
    queryList() {
      this.quertPurchasePlanList();
    },
    async quertPurchasePlanList() {
      const params = {
        pageSize: 5,
        pageNo: 1
      };
      const { code, result } = await this.$store.dispatch(
        "queryStoreRepurchasePlanInfoList",
        params
      );
      if (code === "0") {
        const { records } = result;
        records.forEach(v => {
          v.proportion = v.totalNoticeNum
            ? ToFixed((v.totalPayNum / v.totalNoticeNum) * 100, 2) + "%"
            : "0.00%";
          // v.proportion = v.totalNoticeNum
          //   ? (v.totalPayNum / v.totalNoticeNum).toFixed(2) + "%"
          //   : "0%";
        });
        this.planList = records;
      }
    },
    details(row) {
      this.$router.push({
        name: "ScheduleMessageStatistics",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    edit(row) {
      this.$router.push({
        name: "CreatetPurchasePlan",
        query: {
          type: "edit",
          id: row.id
        }
      });
    },
    operate(row) {
      let params = {
        id: row.id,
        operateType: "enabledState",
        enabledState:
          row.planStatus === "errorStop" || row.planStatus === "stop"
            ? "yes"
            : "no"
      };

      this.$store.dispatch("operateStoreRepurchasePlan", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
        }
      });
    },
    del(row) {
      this.$confirm("是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        row.operateType = "del";
        this.$store.dispatch("operateStoreRepurchasePlan", row).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    detail(i, v) {
      this.active = i;
      this.optionLine.series[0].itemStyle.normal.lineStyle.color = v.background;
      this.optionLine.series[0].areaStyle.color = v.background;
      // this.searchCondition.behaviorType = v.behaviorType;
      this.queryPhysiologicalBehaviorList();
    },
    add() {
      this.$router.push({
        name: "CreatetPurchasePlan"
      });
    },
    morePlan() {
      this.$router.push({
        name: "PurchasePlanList"
      });
    },
    gogogo(v) {
      this.$router.push({
        name: v.pathName,
        query: {
          type: v.type
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.overview {
  margin: 10px;
  .overview-box {
    background: #ffffff;
    margin-top: 10px;
    padding: 20px;
    .title {
      color: #222222;
      font-weight: bold;
      &::before {
        display: inline-block;
        margin-right: 5px;
        content: "";
        width: 4px;
        height: 14px;
        background: #e50065;
        border-top-left-radius: 30px;
        border-bottom-right-radius: 30px;
      }
    }
  }
  .purchase-data {
    box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
    border-radius: 6px;
    .hm-icon {
      width: 66px;
      height: 66px;
      border-radius: 50%;
      text-align: center;
      line-height: 66px;
      background: #feeef5;
      .hmicon {
        font-size: 25px;
        color: #e50065;
      }
    }
    .purchase-name {
      color: #222222;
      font-size: 14px;
    }
    .purchase-val {
      font-size: 24px;
      font-weight: bold;
    }
  }
  .overview-tip {
    background: #e8f5ff;
    border: 1px solid #0081e5;
    font-size: 14px;
    color: #0081e5;
    padding-left: 20px;
  }
}
.tab-btn {
  width: 180px;
  margin-right: 33px;
  // border-top-left-radius: 6px;
  // border-top-right-radius: 6px;

  // background: linear-gradient(180deg, #16ceb9 0%, rgba(255, 255, 255, 0) 100%);
  .hh {
    height: 4px;
    border-radius: 6px 6px 0px 0px;
  }
}
</style>
